import authSlice from './authSlice';

export * from './thunks';

export default authSlice;
